import React from 'react'

import Typography from '@mui/material/Typography'
import { Divider } from '@vividseats/vivid-ui-kit'

import styles from './styles.module.scss'

interface SectionHeaderProps {
    title: string
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title }) => {
    return (
        <div data-testid="ticket-info-section-header" className={styles.sectionHeaderSpacing}>
            <Divider />
            <Typography variant="overline">{title}</Typography>
        </div>
    )
}

export default SectionHeader
